import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BaseChatSession } from '../../../core/sessions/base-chat.session';
import { ChatOutgoingMessage } from '../../../types/chat-session.types';
import { IChatTemplate } from '../../../types/chat-template.types';
import { ChatStateComponent } from '../chat-state/chat-state.component';
import { ChatMessageListComponent } from '../chat-message-list/chat-message-list.component';
import { ChatActivityComponent } from '../chat-activity/chat-activity.component';
import { ChatInputComponent } from '../chat-input/chat-input.component';

@Component({
    selector: 'chat-session-view',
    standalone: true,
    imports: [CommonModule, ChatStateComponent, ChatMessageListComponent, ChatActivityComponent, ChatInputComponent],
    templateUrl: './chat-session-view.component.html',
    styleUrls: ['./chat-session-view.component.scss'],
})
export class ChatSessionViewComponent {
    @Input() public session!: BaseChatSession;

    @Input() public template!: IChatTemplate;

    /** Сохранённая позиция скролла списка сообщений. */
    @Input() public restoreScrollTop: number | null = null;

    @Output() public scrollPositionChange = new EventEmitter<number>();

    @ViewChild(ChatInputComponent) public fileInput?: ChatInputComponent;

    public viewConfig: {
        inputConfig: {
            placeholder?: string;
            showFileInput?: boolean;
        };
    } = {
        inputConfig: {},
    };

    public get allowFiles(): boolean {
        return this.template?.config?.chatManagerViewConfig?.chatInput?.allowFiles ?? false;
    }

    public get allowVoice(): boolean {
        return this.template?.config?.chatManagerViewConfig?.chatInput?.allowVoice ?? false;
    }

    /** Проксирует отправку сообщения в активную сессию. */
    public onMessageSent(message: ChatOutgoingMessage): void {
        this.session.send(message);
    }

    /** Проксирует изменение статуса набора текста в активную сессию. */
    public onTypingChanged(isTyping: boolean): void {
        this.session.notifyTyping(isTyping);
    }
}
